import React, { useRef } from 'react';
import { UseFormReturn } from 'react-hook-form';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import HomeworkForm from './HomeworkForm';
import { Homework } from '../utils/Homework';

// ----------------------------------------------------------------------

type Props = {
  open: boolean;
  onClose: (newHomework?: Homework) => void;
  homework: Homework;
};

export default function HomeworkDialog({ homework, open, onClose }: Props) {
  const formRef = useRef<UseFormReturn<any>>(null);

  const handleClose = () => {
    if (formRef.current) {
      formRef.current.reset(); // Reset the form using the ref
    }
    onClose();
  };

  return (
    <Dialog
      fullWidth
      maxWidth={false}
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: { maxWidth: 1000 }
      }}
    >
      <DialogTitle>Create Homework</DialogTitle>
      <DialogContent>
        <HomeworkForm
          homework={homework}
          onClose={onClose}
          operation="create"
          formRef={formRef} // Pass the ref to the form
        />
      </DialogContent>
    </Dialog>
  );
}
